import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import timerStatusTypes from 'helpers/enums/timerStatusTypes'


function TimerDecoratorFactory(WrappedComponent) {

	class TimerDecorator extends PureComponent {

		constructor(props) {
			super(props)
			this.state = {
				count: 5,
				needs_countdown_intro: false,
				is_timer_complete: false,
				remaining_time: 0,
				timer: props.timer,
			}

		}

		countdown = () => {
			this.setState({
				count: this.state.count - 1,
				needs_countdown_intro: this.state.count > 1,
			})
			if (this.state.count >= 1) {
				this.countdownTimeout = setTimeout(this.countdown, 1000)
			} else {
				// Countdown screen has finished and timer starts to run
				this.onTimerStarted()
			}
		}

		componentDidUpdate(prevProps) {
			if (
				prevProps.timer
				&& !prevProps.timer.state
				&& this.props.timer.state === timerStatusTypes.STOPPED
			) {// Timer Starts Stopped
				this.setState({
					needs_countdown_intro: true,
					timer: this.props.timer,
				})
			} else if (
				prevProps.timer
				&& !prevProps.timer.state
				&& this.props.timer.state === timerStatusTypes.RUNNING
			) {// Timer Starts Running
				const is_timer_complete = this.props.timer.remaining_time === 0
				if (!is_timer_complete) {
					/* Countdown screen has already finished when student
						joins but timer is still running */
					this.onTimerStarted()
				}
				this.setState({
					needs_countdown_intro: false,
					is_timer_complete,
					timer: this.props.timer,
				})
			} else if (
				prevProps.timer
				&& prevProps.timer.state === timerStatusTypes.STOPPED
				&& this.props.timer.state === timerStatusTypes.RUNNING
			) {// Timer Transitions from Stopped to Running
				this.setState({
					timer: {
						...this.props.timer,
						remaining_time: this.state.timer.remaining_time,
					},
				})
				this.countdown()
			}
		}

		timerCompleteHandler = () => {
			this.setState({
				is_timer_complete: true,
			})
			this.props.onTimerEnded()
		}

		onTimerStarted = () => {
			this.props.onTimerStarted()
		}

		componentWillUnmount() {
			clearTimeout(this.countdownTimeout)
		}

		render() {
			const can_start_timer = this.state.timer
				&& this.state.timer.state === timerStatusTypes.RUNNING
				&& this.state.needs_countdown_intro === false
			let timerData

			if (this.state.timer) {
				timerData = {
					can_start_timer,
					needs_countdown_intro: this.state.needs_countdown_intro,
					is_timer_complete: this.state.is_timer_complete,
					count: this.state.count,
					timer: this.state.timer,
					remainingMinutes:
						Math.floor( this.state.timer.remaining_time / 60 ),
					remainingSeconds: this.state.timer.remaining_time % 60,
					onTimerComplete: this.timerCompleteHandler,
				}
			}
			return (<WrappedComponent
				timerData={timerData}
				{...this.props}/>)
		}
	}

	TimerDecorator.propTypes = {
		timer: PropTypes.object,
		onTimerStarted: PropTypes.func,
		onTimerEnded: PropTypes.func,
	}

	TimerDecorator.defaultProps = {
		timer: null,
		onTimerStarted: () => {},
		onTimerEnded: () => {},
	}

	return TimerDecorator
}

export default TimerDecoratorFactory
